// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1t6SD","unreadBadge":"styles_unreadBadge__2u6RS","modalContent":"styles_modalContent__SclYJ","modal":"styles_modal__152Nn"};